<template>
  <div
    id="canvas-container-animation-winterbonusjagd-winter-bg"
    ref="canvascontainer"
    :style="{ opacity: containerOpacity }"
  ></div>
</template>

<script>
import AnimationSpineBaseFunctions from "@/components/animation/animation-spine-base-functions";

export default {
  name: "AnimationSpineWinterbonusjagdWinnerBg",
  mixins: [AnimationSpineBaseFunctions],

  data() {
    return {
      containerId: "canvas-container-animation-winterbonusjagd-winter-bg",
      json: "/assets/spines/events/winterbonusjagd/winterbonus-winscreen.json",
      atlas:
        "/assets/spines/events/winterbonusjagd/winterbonus-winscreen.atlas",
    };
  },

  mounted: function () {
    this.setupAnimation("main", this.onSuccess);
  },
};
</script>

<style lang="scss">
#canvas-container-animation-winterbonusjagd-winter-bg {
  pointer-events: none;
  width: 1390px;
  height: 826px;

  #canvas-animation-winterbonusjagd-winter-bg {
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    bottom: 0;
  }
}
</style>
